module.exports = __webpack_public_path__ + "img/icon_no_coupon.5d5e15a9.png";